// base in 1.7.7
// export this package's api
import Drawer from './Drawer';

export default Drawer;
